import React from 'react'
import { CheckCircleIcon } from '@heroicons/react/24/outline'

const ServiceCard: React.FC = () => {
  const handleRequestSetup = () => {
    const subject = encodeURIComponent('llms.txt Setup Request')
    const body = encodeURIComponent(`Hello,\n\nI'm interested in getting help with setting up llms.txt for my website.\n\nBest regards,`)
    window.location.href = `mailto:hello@andalabx.com?subject=${subject}&body=${body}`
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div className="bg-surface-light border border-neutral-200 rounded-2xl p-4 sm:p-6 md:p-8 my-6 sm:my-8 md:my-12 max-w-3xl mx-auto">
        <div className="text-center mb-6 sm:mb-8">
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-brand-black font-['Arial']">
             Want it done for you?
          </h2>
          <p className="mt-2 sm:mt-3 md:mt-4 text-sm sm:text-base md:text-lg text-neutral-400 max-w-2xl mx-auto px-2 sm:px-0">
            Get expert setup, tailored guidance, and proper deployment — starting at $99.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
          <div className="flex items-start space-x-2 sm:space-x-3">
            <CheckCircleIcon className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-brand-black flex-shrink-0 mt-0.5" />
            <span className="text-sm sm:text-base text-brand-black">Manual llms.txt configuration</span>
          </div>
          <div className="flex items-start space-x-2 sm:space-x-3">
            <CheckCircleIcon className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-brand-black flex-shrink-0 mt-0.5" />
            <span className="text-sm sm:text-base text-brand-black">Custom policy advice</span>
          </div>
          <div className="flex items-start space-x-2 sm:space-x-3">
            <CheckCircleIcon className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-brand-black flex-shrink-0 mt-0.5" />
            <span className="text-sm sm:text-base text-brand-black">Server deployment help</span>
          </div>
          <div className="flex items-start space-x-2 sm:space-x-3">
            <CheckCircleIcon className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-brand-black flex-shrink-0 mt-0.5" />
            <span className="text-sm sm:text-base text-brand-black">Follow-up support</span>
          </div>
        </div>

        <div className="text-center">
          <button onClick={handleRequestSetup} className="inline-flex items-center rounded-md px-3 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold shadow-sm btn-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-200">
            Request Setup
          </button>
        </div>
      </div>
    </div>
  )
}

export default ServiceCard 